export default {
  privacy: {
    lastUpdated: '최종 업데이트: 2022년 3월 18일',
    companyName: 'Linktivity Inc.',
    title: '개인정보 처리방침',
    personalInfoProtectionPolicy: '개인정보 보호 정책',
    personalInfoProtectionDescription:
      'Linktivity Inc.(이하 "회사")는 예약 웹사이트 LINKTIVITY 등을 통해 고객으로부터 개인정보를 수집합니다. 회사는 고객이 안심하고 편리하게 예약할 수 있도록 고객 개인정보를 보호하는 것이 매우 중요하다고 생각하며, 다음에 명시된 규정을 준수하여 개인정보를 처리합니다.',
    customerDataManager: '고객 데이터 관리자',
    companyAddress:
      '일본 도쿄도 치요다구 우치사이와이초 2-1-6 히비야 파크프론트 19층',
    acquisition: '수집',
    acquisitionDescription:
      '회사는 법령에서 필요한 경우 고객의 동의를 얻은 후 명시된 이용 목적을 달성하기 위해 필요한 최소한의 개인정보만을 수집합니다.',
    usage: '이용',
    usageDescription:
      '회사는 고객으로부터 수집한 개인정보를 명시된 이용 목적을 달성하기 위해서만 이용합니다.',
    storage: '보관 및 저장',
    storageDescription:
      '회사는 고객으로부터 수집한 개인정보가 외부로 유출되지 않도록 시스템 보안을 주의하여 개인정보를 보관 및 저장합니다.',
    destruction: '파기 및 삭제',
    destructionDescription:
      '회사는 더 이상 필요하지 않은 개인 데이터를 필요 없어진 시점에서 지체 없이 파기합니다.',
    customerInquiry: '고객 문의에 대한 대응',
    customerInquiryDescription:
      '회사는 고객이 보유한 개인 데이터의 이용 목적 통지 요청, 공개 요청, 정정/추가/삭제 요청, 이용 중단/삭제 요청 및 제3자 제공 중단 요청에 대해 관련 법령에 따라 대응합니다.',
    safetyMeasures: '안전 관리 조치',
    safetyMeasuresDescription:
      '회사는 LINKTIVITY 서비스에 관련된 모든 직원이 개인정보의 중요성을 이해하도록 교육하고, 개인정보 보호를 위해 필요하고 적절한 조치를 취합니다.',
    tableOfContents: '목차',
    policy1: {
      title: '회사가 수집하는 개인정보 및 이용 목적',
      description:
        '회사는 다음에 명시된 이용 목적으로 고객의 주소, 이름, 생년월일, 연락처, 이메일 주소, 여권 번호 등의 개인정보를 수집하고 이용합니다. 회사는 고객의 동의 없이 민감한 개인정보를 수집하지 않습니다. 개인정보 수집 시점에 개인정보의 이용 목적이 공개되지 않은 경우, 회사는 고객에게 이용 목적을 통지하거나 공개합니다. 회사는 부모의 동의 없이 13세 미만의 아동으로부터 개인정보를 수집하지 않습니다. 13세 미만의 아동 개인정보를 제공하는 경우, 부모의 동의를 얻은 것으로 간주하지만, 동의를 얻지 못했음이 명확해지면 부모에게 연락하고 관련 목적 외에는 개인정보를 이용하지 않습니다.',
      serviceUsage: {
        title: 'LINKTIVITY 서비스 이용(회원 가입 등)',
        description:
          'LINKTIVITY 서비스 이용을 위해 고객 개인정보는 회사 내부에서 공유됩니다.',
        legalBasis: '고객이 요청한 서비스 및 기능을 제공하기 위해 필요합니다.'
      },
      ticketPurchase: {
        title: '티켓 구매 신청',
        infoItems:
          '회사는 상품 제공업체로부터의 티켓 구매 신청을 처리할 때 고객의 이름, 결제 정보, 여권 번호 및 건강 상태와 병력을 포함한 고객의 건강 상태 관련 정보를 수집합니다.',
        purpose:
          '회사는 고객 개인정보를 수집하여 상품 제공업체로부터의 티켓 구매 자격을 확인하고 티켓 및 관련 수수료의 결제를 처리합니다. 이 목적을 위해 회사는 고객 개인정보를 상품 제공업체, 운송 회사, 결제 처리업체 및 기타 서비스 제공업체(해외 제공업체 포함)에 제공할 수 있습니다.',
        legalBasis: '고객이 요청한 서비스 및 기능을 제공하기 위해 필요합니다.'
      },
      newsletter: {
        title: '뉴스레터(이메일 매거진 등) 전송 및 고객 통신',
        legalBasis: '고객의 동의에 기반하여 수집합니다.'
      },
      advertising: {
        title: '소셜 미디어 및 광고 배포 플랫폼을 통한 광고',
        legalBasis: '고객의 동의에 기반하여 수집합니다.'
      },
      survey: {
        title: '설문조사 참여 요청',
        legalBasis:
          '예약 웹사이트, 상품 및 서비스 개선을 위해 고객의 동의에 기반하여 수집합니다.'
      },
      analysis: {
        title: '고객 정보 분석 및 관리',
        legalBasis:
          '예약 웹사이트, 상품 및 서비스를 개선함으로써 고객의 정당한 이익을 추구하고 보호하기 위해 필요합니다.'
      },
      fraudDetection: {
        title: '신용카드 등의 부정 사용 탐지',
        legalBasis:
          '고객의 신용카드 보안을 보장하고 고객의 정당한 이익을 추구하기 위해 필요합니다.'
      }
    },
    policy2: {
      title: '개인 데이터의 제3자 제공',
      description:
        '회사는 다음의 경우를 제외하고 고객으로부터 수집한 개인 데이터를 제3자에게 제공하지 않습니다.',
      case1:
        '고객이 본 개인정보 처리방침 또는 기타 수단을 통해 제3자(상품 제공업체, 해외 여행사, 소셜 미디어 제공업체, 광고 배포 서비스 회사 등)에게 개인 데이터 제공에 사전 동의한 경우',
      case2:
        '명시된 이용 목적을 달성하는 데 필요한 범위 내에서 개인 데이터 처리를 제3자에게 위탁한 경우',
      case3: '법령에 기반하여 제공을 요청받은 경우',
      case4:
        '인명, 신체 또는 재산 보호를 위해 필요하고 고객의 동의를 얻기 어려운 경우',
      case5:
        '공중 보건 증진 또는 아동의 건전한 발달 추진을 위해 특히 필요하고 고객의 동의를 얻기 어려운 경우',
      case6:
        '정부 또는 지방 정부가 법령에 규정된 업무 수행을 위해 협력이 필요하고 고객의 동의를 얻으면 해당 업무 수행에 지장을 줄 수 있는 경우'
    },

    policy3: {
      title: '개인 데이터 처리의 위임',
      description:
        '회사가 명시된 이용 목적을 달성하는 데 필요한 범위 내에서 고객 개인 데이터 처리를 제3자에게 위임할 때, 회사는 위임받은 기관에 필요하고 적절한 감시를 제공합니다. 위임받은 기관이 다른 기관으로 재위임하는 경우, 회사는 위임받은 기관이 재위임 기관에 필요하고 적절한 감시를 제공하는지 직접 또는 간접적으로 감시합니다. 재위임 기관이 다시 위임하는 경우도 동일하게 적용됩니다.'
    },
    policy4: {
      title: '쿠키 정보 등의 수집',
      cookie: {
        title: '쿠키',
        description1:
          '쿠키는 사용자에 대한 정보를 포함하고 사용자의 하드드라이브에 저장되는 데이터 파일입니다. 회사는 쿠키를 개인 식별에 사용하지 않습니다. 쿠키는 세션 쿠키이며 사용자가 브라우저를 닫으면 보관되지 않습니다. 쿠키는 고객 서비스 개선, 웹사이트 커스터마이제이션, 광고 효과 측정 등의 목적으로 사용됩니다.',
        description2:
          '회사는 쿠키를 통계 데이터로 분석하여 고객의 관심사를 파악하고 활용합니다. 쿠키는 또한 무단 접근 방지에도 사용됩니다.',
        description3:
          '쿠키는 고객의 선호도에 따라 비활성화할 수 있지만, 이렇게 하면 고객은 LINKTIVITY에서 예약할 수 없습니다.'
      },
      logFile: {
        title: '로그 파일',
        description1:
          '회사는 특정 정보를 자동으로 수집하여 로그 파일에 저장합니다. 이 정보에는 IP(인터넷 프로토콜) 주소, 브라우저 유형, ISP(인터넷 서비스 제공업체) 이름, 참조/종료 페이지, 운영 체제 및 날짜/타임스탬프가 포함됩니다. 회사는 이 정보를 무단 접근 모니터링 및 고객 트렌드 분석, 웹사이트 관리, 고객 행동 추적에 사용합니다.',
        description2:
          '그러나 회사는 이 정보를 개인을 식별할 수 없는 방식으로 사용하며, 수집한 정보를 위에 명시된 목적 이외의 목적으로 사용하지 않습니다.'
      },
      webBeacon: {
        title: '웹 비콘',
        description:
          '회사는 웹 비콘을 접근 분석 및 제휴 프로그램을 위해 사용합니다. 회사는 웹 비콘을 위에 명시된 목적 이외의 목적으로 또는 개인 식별을 위해 사용하지 않습니다.'
      },
      statisticalAnalysis: {
        title: '통계 분석',
        description1:
          '회사는 제3자 접근 분석 도구를 사용하여 어느 사이트와 서비스가 인기 있는지 파악하고 LINKTIVITY 내에서 고객이 접근한 페이지와 페이지 기록을 기록합니다.',
        description2:
          '회사는 이 데이터를 사용하여 특정 분야에 관심을 보인 고객에게 LINKTIVITY 내에서 고객의 관심에 맞는 콘텐츠와 광고를 제공합니다.',
        description3:
          '회사는 또한 개인을 식별하지 않는 통계 정보를 수집할 수 있습니다. 또한 회사가 수집한 쿠키 정보와 다른 기관이 수집한 쿠키 정보를 제3자 접근 분석 도구 플랫폼에서 양쪽이 볼 수 있도록 할 수 있습니다.'
      }
    },
    policy5: {
      title: '익명 처리된 정보의 처리',
      creation: {
        title: '익명 처리된 정보의 작성',
        description1:
          '회사는 익명 처리된 정보를 작성할 때 다음 조치를 취합니다. 익명 처리된 정보는 법령 요구 사항에 따라 특정 개인을 식별할 수 없는 방식으로 개인정보를 처리하여 얻은 개인 관련 정보이며, 원본 개인정보를 복구할 수 없도록 합니다.',
        description2:
          '① 법령이 규정한 기준에 따라 적절하게 처리함 ② 법령이 규정한 기준에 따라 삭제된 정보 및 처리 방법 관련 정보의 공개를 방지하기 위한 안전 관리 조치를 시행함 ③ 작성된 익명 처리된 정보에 포함된 개인 관련 정보의 항목을 공개함 ④ 익명 처리된 정보 작성에 사용된 개인정보로부터 원본 개인을 식별하기 위한 조치를 취하지 않음'
      },
      provision: {
        title: '익명 처리된 정보의 제공',
        description:
          '회사가 익명 처리된 정보를 제3자에게 제공할 때, 회사는 익명 처리된 정보에 포함된 개인 관련 정보의 항목과 제공 방법을 공개하고 수신자에게 제공되는 정보가 익명 처리된 정보임을 명시합니다.'
      },
      disclosure: {
        title: '익명 처리된 정보에 대한 공개',
        creationSubtitle: '익명 처리된 정보 작성',
        creationDescription:
          '회사가 보유한 다음 고객 개인정보에 대해 회사는 특정 개인을 식별하지 않고 원본 개인정보를 복구할 수 없도록 적절한 조치를 취한 후 지속적으로 익명 처리된 정보를 작성합니다.',
        itemsTitle: '익명 처리된 정보에 포함된 개인 관련 정보의 항목',
        itemsDescription:
          '플랫폼 서비스 제공과 관련하여 수집된 정보: 구매 날짜, 참가 날짜, 바우처 언어, 판매 금액 범위, 참가자 수, 예약 상태(확정 또는 취소됨), 공급업체 위치 및 도도부현 정보, 여행사 위치 국가.',
        thirdPartyTitle: '익명 처리된 정보의 제3자 제공',
        thirdPartyDescription:
          '회사가 작성하거나 보유한 익명 처리된 정보에 대해 회사는 정보가 익명 처리된 정보임을 명시하면서 지속적으로 제3자에게 제공합니다.',
        provisionMethod:
          '암호로 보호된 전자 파일을 전자 통신 수단(이메일, 서버 업로드, API 통합 등) 또는 물리 미디어(DVD 등)를 통해 전송.'
      }
    },
    policy6: {
      title: '개인 데이터의 안전 관리 조치',
      description1:
        '회사는 개인 데이터의 유출, 절도, 오용, 무단 접근, 변조 및 파괴를 방지하기 위해 조직적, 기술적, 물리적 안전 관리 조치를 시행합니다. 회사가 개인 데이터를 저장하는 서버에 대한 접근은 ID 및 비밀번호 접근 권한이 있는 승인된 직원으로 제한되며, 특정 개인 데이터에 대한 접근은 데이터 관리를 위해 필요한 최소한의 직원에게만 부여됩니다.',
      description2:
        '또한 신용카드 정보를 포함한 개인 데이터는 여러 데이터 센터에 분산되어 보안 환경에 저장됩니다. 회사는 예약 거래와 관련된 모든 페이지에 대해 보안 소켓 레이어(SSL) 암호화를 사용합니다. SSL 준수 브라우저를 사용하면 인터넷을 통해 전송되는 개인 데이터 및 신용카드 정보의 기밀성을 유지할 수 있습니다.',
      description3:
        '고객 개인 데이터를 처리하는 회사 직원은 터미널을 떠날 때 암호로 보호된 화면 보호기를 사용합니다.',
      description4:
        '또한 회사는 특정 부서는 월 1회, 전사적으로는 최소 연 2회 이상의 빈도로 개인정보의 중요성 등에 관한 교육 훈련을 실시합니다. 회사는 또한 이러한 훈련에 대한 기록을 유지합니다.'
    },
    policy7: {
      title: '개인 데이터 처리와 관련된 고객 권리',
      description:
        '2016년 4월 27일자 EU 일반 데이터 보호 규정(GDPR) 2016/679에 기반하여 고객은 개인 데이터 처리와 관련하여 다음 권리를 가집니다:',
      right1: '접근 권',
      right2: '정정 권',
      right3: '삭제 권(잊혀질 권리) 및 처리 제한 권',
      right4: '데이터 포호드/성 권',
      right5: '이의 제기 권',
      right6: '프로파일링을 포함한 자동화된 처리 기반 결정에 종속되지 않을 권.'
    },
    policy8: {
      title: '공개, 정정, 이용 중단 등의 요청',
      description1:
        '회사는 고객이 보유한 개인 데이터의 이용 목적 통지 요청, 공개 요청, 정정/추가/삭제 요청, 이용 중단/삭제 요청 및 제3자 제공 중단 요청(총칭하여 "공개 등의 요청")에 대해 아래 11절에 명시된 연락처를 통해 대응합니다.',
      description2:
        '또한 회사는 고객의 계정 페이지에서 회원 정보 변경 및 확인과 이메일 매거진 배포 중단 등의 고객 요청에 응합니다.'
    },
    policy9: {
      title: '외부 링크',
      description:
        'LINKTIVITY 홈페이지에는 다른 웹사이트로의 링크가 포함되어 있습니다. 본 개인정보 처리방침은 LINKTIVITY 홈페이지를 통해 수집된 정보에만 적용되며, 회사는 다른 웹사이트의 개인정보 처리방침 또는 콘텐츠에 대해 책임을 지지 않습니다. 고객은 링크된 웹사이트의 개인정보 처리방침을 읽고 개인정보가 어떻게 처리되는지 확인하도록 요청됩니다.'
    },
    policy10: {
      title: '개인정보 처리방침 변경',
      description:
        '회사는 본 개인정보 처리방침을 LINKTIVITY 홈페이지에 게시하여 고객이 회사가 어떤 개인정보를 수집하고 무엇을 위해 수집하고 어떻게 사용하는지 항상 알 수 있도록 합니다. 개인정보 처리방침의 변경도 LINKTIVITY 홈페이지에 게시되고 고객에게 공개됩니다.'
    },
    policy11: {
      title: '연락처',
      description1:
        '회사의 개인정보 처리방침, 회사의 개인정보 보호 노력, 고객 개인정보 수집 및 사용 또는 공개 등의 요청과 관련된 질문은 아래 연락처 양식을 사용하십시오. 담당자가 5영업일 이내에 응답하겠습니다.',
      company: 'Linktivity Inc.',
      address:
        '일본 도쿄도 치요다구 우치사이와이초 2-1-6 히비야 파크프론트 19층',
      dpoContact: '데이터 보호 담당자 연락처: dpo@linktivity.co.jp'
    },
    contentLabels: {
      acquisitionOfPersonalInfo: '수집된 개인정보',
      specificPurpose: '구체적인 이용 목적',
      legalBasis: '법적 근거:',
      provisionMethod: '제공 방법'
    }
  }
};
